import { styled, Theme } from '@mui/material';

export const sxStyles = {
  bgColor: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
  }),
  container: {
    padding: '2.5rem 1.25rem',
  },
  sectionTitle: (theme: Theme) => ({
    color: theme.palette.primary.main,
    marginBottom: '2.5rem',
  }),
  categoriesWrap: (theme: Theme) => ({
    '> :not(:last-of-type)': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  }),
  categoryTitle: {
    marginTop: '1.5rem',
    marginBottom: '1rem',
    textTransform: 'uppercase',
  },
  categoryItemsWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem 5rem',
    marginBottom: '1.5rem',
  },
  tooltipIcon: {
    marginLeft: '0.5rem',
    height: '20px',
    cursor: 'pointer',
  },
};

export const StyledCategoryItem = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  maxWidth: '253px',
  width: '100%',

  '& > div:first-of-type': {
    marginRight: '0.75rem',
  },
}));
